import FormulardatenViewDto from "../form/dto/FormulardatenViewDto";
import BackendService from "../common/BackendService";
import OpRkSchnelltarifierungResp from "./dto/OpRkSchnelltarifierungResp";
import GoogleTagManager from "../../gtm/GoogleTagManager";

const rkSchnelltarifierung = (formDto: FormulardatenViewDto) => {
    const params = {};
    const data = {
        formIhrTier: formDto.ihrTier,
        formAngebot: formDto.angebot
    }

    const result = BackendService.postData('rest/op/rk', params, data)
        .then(root => {
            return root as OpRkSchnelltarifierungResp;

        })
        .catch(error => {
            // TODO Fuest logging
            throw error;
        });

    // GoogleTagManager
    const produktMitSchutzbrief = formDto.angebot?.produktMitSchutzbrief;
    const sb = formDto.angebot?.selbstbehalt;
    const vs = formDto.angebot?.vs;
    const zw = formDto.angebot?.zahlungsweise;

    GoogleTagManager.fireEventTarifierung(produktMitSchutzbrief, sb, vs, zw);

    return result;

}

const RkConsumer = {
    rkSchnelltarifierung
}

export default RkConsumer;